/**
 * Laboratoriya ishlari reyestri. Engine ichida birorta lab yo'q — ular domain pack
 * (packs/<id>/labs/*.json) dan `registerLabs` orqali yuklanadi (zod tekshiruvi va
 * uz-Cyrl to'ldirish pack yuklovchida bajariladi).
 */
import type { LabDefinition } from '../scenario/schema';

const REGISTRY = new Map<string, LabDefinition>();

export function registerLabs(list: readonly LabDefinition[]): void {
  for (const lab of list) REGISTRY.set(lab.id, lab);
}

/** Testlar uchun */
export function clearLabs(): void {
  REGISTRY.clear();
}

/** Barcha yuklangan lablar (pack tartibida) */
export function allLabs(): LabDefinition[] {
  return [...REGISTRY.values()];
}

export function getLab(id: string): LabDefinition {
  const lab = REGISTRY.get(id);
  if (!lab) throw new Error(`Unknown lab: ${id} (pack yuklanganmi?)`);
  return lab;
}

export function labIds(): string[] {
  return [...REGISTRY.keys()];
}
